import { useState } from "react";
import { ProjectCompleteThread } from "../../data-models/project-complete-thread";
import { ProjectModalProps } from "../../data-models/props";
import { DataService } from "../../services/data-service";
import { useStoreActions, useStoreState } from "../../store/data-store";
import ColourSwatch from "../colour-swatch/colour-swatch";

const CompleteProjectModal = ({ closeModal, project }: ProjectModalProps) => {

    const user = useStoreState(store => store.user);
    const [threads, setThreads] = useState(project.threads.map(x => 0));

    const setInventory = useStoreActions(store => store.setInventory);

    function handleReturnedMetersChange(index: number, assignedMeters: number) {
        console.log("number changing " + assignedMeters);
        const newArray = [...threads];
        newArray[index] = assignedMeters;
        setThreads(newArray);
    }

    const completeProject = () => {
        async function completeProjectAsync() {
            const projectThreads = project.threads.map((t, idx) => {
                return {
                    id: t.id,
                    colourNumber: t.colourNumber,
                    returnedMeters: threads[idx]
                } as ProjectCompleteThread;
            })
            project.threads.forEach((t,idx) =>{
                t.assignedMeters = threads[idx]
            })
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            await dataService.completeProject(user.id, tokens.accessToken, project.id, projectThreads);

            const inventory = await dataService.getInventory(user.id, tokens.accessToken);
            setInventory(inventory);

            closeModal();

        }
        completeProjectAsync();
    }



    return (
        <div className="modal-container">
            <div className="overlay" onClick={closeModal} />
            <div className='modal'>
                <div className="user-input-data">
                    <h2>{project.name}</h2>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Colour #</th>
                                    <th>Assgn'd</th>
                                    <th>Ret'nd</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                project.threads.map((t, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td>{t.colourNumber}</td>
                                            <td>{t.assignedMeters}</td>
                                            <td><input className="form-input meters-input" type="number" min="0" max={t.assignedMeters} onChange={(e) => {handleReturnedMetersChange(idx, Number(e.target.value))}} value={threads[idx]} /></td>
                                            <td><ColourSwatch colourNumber={t.colourNumber} /></td>
                                        </tr>
                                    )})
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-actions">
                    <button className="small-button" onClick={closeModal} >Cancel</button>
                    <button className='procom-button small-button' onClick={completeProject} >Complete</button>
                </div>

            </div>
        </div>
    )

}

export default CompleteProjectModal;